"use client";

import { MapPin, Truck, Shield, RotateCcw } from "lucide-react";
import { ServiceItem } from "./ServiceItem";
import { DeliveryEstimate, DeliveryService } from "./types";

// Local type that allows React components for icons
type LocalDeliveryService = Omit<DeliveryService, 'icon'> & {
  icon: any; // Using any to avoid React type conflicts
};
interface DeliveryInfoProps {
  deliveryInfo: DeliveryEstimate;
  pincode: string;
}
export const DeliveryInfo = ({ deliveryInfo, pincode }: DeliveryInfoProps) => {
  const services: LocalDeliveryService[] = [
    {
      icon: Truck,
      title: "Standard Delivery",
      subtitle: "Free delivery",
      value: deliveryInfo.standard
    },
    // Only show COD if available
    ...(deliveryInfo.cod ? [
      {
        icon: Shield,
        title: "Cash on Delivery",
        subtitle: "Pay when you receive",
        value: 'Available',
        valueColor: 'text-green-600'
      }
    ] : []),
    {
      icon: RotateCcw,
      title: "Easy Returns",
      subtitle: "Hassle-free returns",
      value: deliveryInfo.returnPolicy
    }
  ];
  const showDays = typeof deliveryInfo.estimated_days === 'number' && deliveryInfo.estimated_days <= 5;
  return (
    <div className="space-y-3 p-4 bg-gray-50 rounded-lg">
      <div className="flex items-center gap-3 pb-2 border-b border-gray-200">
        <MapPin className="w-4 h-4 text-green-600" />
        <span className="text-sm font-medium text-green-600">
          Delivery available to {pincode}{showDays ? ` in ${deliveryInfo.estimated_days} days` : ''}
        </span>
      </div>
      
      <div className="space-y-3">
        {services.map((service, index) => (
          <ServiceItem key={index} service={service} />
        ))}
      </div>
    </div>
  );
};